export default function generateTableRange(data, { schema }) {
    const startCell = 'A1';

    let endCellColumn = 'B';
    let endCellRow = '2';
    let numRows = 0;
    let numCols = 0;

    console.log(schema);

    if (schema) {
        for (const column of schema) {
            // If at least one schema column has a title,
            // then count row.
            if (column.column) {
                numCols = schema.length;
                numRows++;
                break;
            }
        }

        console.log(data);

        numRows = numRows || data[0].length;
        numRows += data.length;

        const carry = Math.floor(numCols / 26);
        console.log(carry, 'carry');
        endCellColumn = new Array(carry).fill('Z').join('');

        if (numCols % 26 !== 0) {
            endCellColumn = endCellColumn.concat(
                String.fromCharCode(64 + (numCols % 26))
            );
        }
        endCellRow = numRows;
    }

    return `${startCell}:${endCellColumn}${endCellRow}`;
}
